var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(this.$route.path!='/show')?_c('dingbu'):_vm._e(),_c('router-view',{staticStyle:{"min-height":"calc(100vh - 332px)"}}),(this.$route.path!='/show')?_c('foot'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }